const PARTNERS = [
  "Fonterra Alpine",
  "Nordic Green Dairy",
  "Highland Meadow Co.",
  "Alpine Blossom Farm",
  "Golden Valley Dairy",
  "Willowbrook Ranch",
  "Sunfield Pasture",
  "Emerald Bay Farm",
  "Silverstream Dairy",
  "Meadowline Holdings",
];

export default function PartnerMarquee() {
  return (
    <section className="w-full bg-background-50 border-y border-background-200/70">
      <div className="w-full px-6 md:px-10 lg:px-14 py-8 md:py-10">
        <div className="flex items-center gap-4 mb-6">
          <div className="h-px flex-1 bg-background-300/70"></div>
          <span className="text-xs tracking-[0.3em] uppercase text-foreground-600">
            Trusted by global dairy farms
          </span>
          <div className="h-px flex-1 bg-background-300/70"></div>
        </div>

        <div className="relative overflow-hidden">
          <div className="marquee-track flex whitespace-nowrap gap-10 md:gap-14 will-change-transform">
            {[...PARTNERS, ...PARTNERS].map((name, i) => (
              <div
                key={`${name}-${i}`}
                className="flex items-center gap-3 text-foreground-700"
              >
                <i className="ri-shield-check-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
                <span
                  className="text-lg md:text-2xl font-heading font-medium tracking-tight"
                  style={{ fontFamily: "Fraunces, serif" }}
                >
                  {name}
                </span>
              </div>
            ))}
          </div>
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 bg-gradient-to-r from-background-50 to-transparent"></div>
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 bg-gradient-to-l from-background-50 to-transparent"></div>
        </div>
      </div>
    </section>
  );
}